export default __webpack_public_path__ + "static/media/image2.5ca972ae.jpeg";